import { type PropsWithChildren } from 'react';
import { StyleSheet } from 'react-native';
import { DecorativeText, theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const ProductDetailsSectionTitle = (props: Props) => {
  const { children } = props;

  return (
    <DecorativeText sizeMatch={['32']} style={styles.title} bold>
      {children}
    </DecorativeText>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  title: {
    color: theme.colors.KALE,
    marginBottom: theme.spacing['4'],
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = PropsWithChildren;
